var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 16C13.2239 16 13 16.2239 13 16.5C13 16.7761 13.2239 17 13.5 17H18.5C18.7761 17 19 16.7761 19 16.5C19 16.2239 18.7761 16 18.5 16H13.5Z",
    fill: "#00112B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18C13.2239 18 13 18.2239 13 18.5C13 18.7761 13.2239 19 13.5 19H15.5C15.7761 19 16 18.7761 16 18.5C16 18.2239 15.7761 18 15.5 18H13.5Z",
    fill: "#00112B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12C13.4477 12 13 12.4477 13 13C13 13.5523 13.4477 14 14 14H15C15.5523 14 16 13.5523 16 13C16 12.4477 15.5523 12 15 12H14Z",
    fill: "#00112B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 22.5C22 22.7022 21.8782 22.8845 21.6913 22.9619C21.5045 23.0393 21.2894 22.9966 21.1464 22.8536L19.5541 21.2612L18.4 22.8C18.313 22.916 18.18 22.9885 18.0354 22.9987C17.8909 23.009 17.7489 22.956 17.6464 22.8536L16 21.2071L14.3536 22.8536C14.2511 22.956 14.1091 23.009 13.9646 22.9987C13.82 22.9885 13.687 22.916 13.6 22.8L12.4459 21.2612L10.8536 22.8536C10.7106 22.9966 10.4955 23.0393 10.3087 22.9619C10.1218 22.8845 10 22.7022 10 22.5V11C10 9.89543 10.8954 9 12 9H20C21.1046 9 22 9.89543 22 11V22.5ZM20 10H12C11.4477 10 11 10.4477 11 11V21.2929L12.1464 20.1464C12.2489 20.044 12.3909 19.991 12.5354 20.0013C12.68 20.0115 12.813 20.084 12.9 20.2L14.0541 21.7388L15.6464 20.1464C15.8417 19.9512 16.1583 19.9512 16.3536 20.1464L17.9459 21.7388L19.1 20.2C19.187 20.084 19.32 20.0115 19.4646 20.0013C19.6091 19.991 19.7511 20.044 19.8536 20.1464L21 21.2929V11C21 10.4477 20.5523 10 20 10Z",
    fill: "#00112B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBill);
export default __webpack_public_path__ + "static/media/bill.afb8f04c7fa031e591f8ba24cb9e52cb.svg";
export { ForwardRef as ReactComponent };